import "../assets/css/Loader.css";
const Loader=()=>
{
    return(
        <div className="loader">
            <div className="dot-flashing"></div>
        </div>
    )
}

export default Loader;